import React from "react";
import red from '../../assets/redStatus_icon.svg';
import yellow from '../../assets/yellowStatus_icon.svg';
import green from '../../assets/greenStatus_icon.svg';
import na from '../../assets/na_icon.svg';
import { Grid } from "@material-ui/core";

const SafetyPrintHeader = () => {

    return(
        <Grid container className="safety-print-header pt-2" spacing={2}>
            <Grid item xs={12}>
                <label className="inspection-details-lbl text-2xl">Inspection Details</label>
            </Grid>
            <Grid item xs={12}>
                <div className="safety-header-icons py-2">
                    <img src={green} alt = "green square"></img><div>Checked and OK</div>
                    <img src={yellow} alt = "yellow square"></img><div>May require follow-up attention</div>
                    <img src={red} alt = "red square"></img><div>Requires immediate attention</div>
                    <img src={na} alt = "blank square"></img><div>Does not apply</div>
                </div>
            </Grid>
        </Grid>
        
    )
}

export default SafetyPrintHeader